/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Work_Life_Balance26Inputs */

const en__field_enum_csjensblank_work_life_balance26 = /** @type {(inputs: _Field_Enum_Csjensblank_Work_Life_Balance26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions about „Work-Life-Balance"`)
};

const de__field_enum_csjensblank_work_life_balance26 = /** @type {(inputs: _Field_Enum_Csjensblank_Work_Life_Balance26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbarkeit von Familie und Beruf „Work-Life-Balance"`)
};

/**
* | output |
* | --- |
* | "Questions about „Work-Life-Balance\"" |
*
* @param {_Field_Enum_Csjensblank_Work_Life_Balance26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_work_life_balance26 = /** @type {((inputs?: _Field_Enum_Csjensblank_Work_Life_Balance26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Work_Life_Balance26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_work_life_balance26(inputs)
	return de__field_enum_csjensblank_work_life_balance26(inputs)
});
export { _field_enum_csjensblank_work_life_balance26 as "_field_enum_CSJENSBLANK_WORK_LIFE_BALANCE" }